import React from "react";
import { Box, Divider, Spacer, Stack } from "digiwash-components";

function SkeletonAddressesList() {
  return (
    <Box p="l" br="xm" bg="common.white" style={{ width: "100%", height: 112 }}>
      <Stack>
        <Box
          bg="neutrals.250"
          br="s"
          style={{
            width: 24,
            height: 24,
          }}
        />
        <Spacer size="m" />
        <Box
          bg="neutrals.250"
          br="s"
          style={{
            width: 114,
            height: 24,
          }}
        />
      </Stack>
      <Divider size="m" />
      <Stack>
        <Box
          bg="common.white"
          br="s"
          style={{
            width: 24,
            height: 24,
          }}
        />
        <Spacer size="m" />
        <Box
          bg="neutrals.250"
          br="s"
          style={{
            width: 290,
            height: 16,
          }}
        />
      </Stack>
      <Divider size="s" />
      <Stack>
        <Box
          bg="common.white"
          br="s"
          style={{
            width: 24,
            height: 24,
          }}
        />
        <Spacer size="m" />
        <Box
          bg="neutrals.250"
          br="s"
          style={{
            width: 201,
            height: 16,
          }}
        />
      </Stack>
    </Box>
  );
}

export default SkeletonAddressesList;
